const MIN_STRUCTURE = {
  logiciel_formation: 200,
  logiciel_compta: 20,
  compte_bancaire: 10,
  assurance_rcp: 15,
  assurance_decennale: 250,
  comptable: 250,
  cet_cvae_cfe: 27,
  mutuelle_prevoyance: 75,
};

const ARRONDI = (n) => Math.round(n * 100) / 100;

/**
 * Calcule les charges de structure et de fonctionnement communs aux statuts EI/SASU
 * @param {object} params
 * @param {object} params.charges
 * @param {string} params.metier
 * @param {number} params.caHT
 * @param {(ctx: { caHT: number, charges: object }) => number} params.logicielFormationMin
 */
export function computeStructureCharges({ charges = {}, metier = '', caHT = 0, logicielFormationMin, coeff = 1 }) {
  const isBatiment = metier === 'Bâtiment, travaux';
  const isAlimentaire = metier === 'Production alimentaire, culinaire';
  const isFormation = metier === 'Formation professionnelle';

  const frais_fonctionnement = ARRONDI(
    ((charges.loyer || 0) +
    (charges.internet_telephone || 0) * 0.5 +
    (charges.indemnites_km || 0) +
    (charges.deplacements || 0) +
    (charges.communication_pub || 0) +
    (charges.consommables || 0) +
    (charges.repas_affaires || 0)) / coeff
  );

  const label_bio = isAlimentaire && (charges.label_bio || 0) > 0
    ? Math.max((charges.label_bio || 0) / coeff, (160 + 180) / 12)
    : 0;
  const code_barres = isAlimentaire ? (charges.code_barres || 0) / coeff : 0;

  const formationMin = typeof logicielFormationMin === 'function'
    ? logicielFormationMin({ caHT, charges })
    : MIN_STRUCTURE.logiciel_formation;
  const logiciel_formation = isFormation
    ? Math.max((charges.logiciel_formation || 0) / coeff, formationMin)
    : 0;

  const logiciel_compta = Math.max((charges.logiciel_compta || 0) / coeff, MIN_STRUCTURE.logiciel_compta);
  const compte_bancaire = Math.max((charges.compte_bancaire || 0) / coeff, MIN_STRUCTURE.compte_bancaire);
  const assurance_rcp = isBatiment ? 0 : Math.max((charges.assurance_rcp || 0) / coeff, MIN_STRUCTURE.assurance_rcp);
  const assurance_decennale = isBatiment
    ? Math.max((charges.assurance_decennale || 0) / coeff, MIN_STRUCTURE.assurance_decennale)
    : 0;
  const comptable = Math.max((charges.comptable || 0) / coeff, MIN_STRUCTURE.comptable);
  const cet = Math.max((charges.cet_cvae_cfe || 0) / coeff, MIN_STRUCTURE.cet_cvae_cfe);
  const mutuelle = Math.max((charges.mutuelle_prevoyance || 0) / coeff, MIN_STRUCTURE.mutuelle_prevoyance);

  const autres_frais_structure = ARRONDI(
    label_bio +
      code_barres +
      logiciel_formation +
      logiciel_compta +
      compte_bancaire +
      assurance_rcp +
      assurance_decennale +
      comptable +
      cet +
      mutuelle
  );

  return {
    frais_fonctionnement,
    autres_frais_structure,
  };
}
